/**
 * `planner/getbyid/{id}` expects the work order number without the client-side `W` prefix
 * (e.g. `W450593` → `450593`). Numeric process ids are unchanged.
 *
 * @param {string | number} id
 * @returns {string}
 */
export function normalizePlannerGetByIdPathSegment(id) {
  if (id == null || id === '') return '';
  const s = String(id).trim();
  const withoutW = s.replace(/^W/i, '');
  return withoutW === '' ? s : withoutW;
}
